import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {ViewStoricoConservazioneComponent} from './view-storico-utilizzo';

let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

  $stateProvider
    .state('usersettings.view-storico-utilizzo', {
        url: '/view-storico-utilizzo',
        views: {
          'userContent': {
            template: '<view-storico-conservazione-component></view-storico-conservazione-component>'
          }
        },
        ncyBreadcrumb: {
          label: 'Visualizza storico conservazione',
          parent: 'home.home-index',
        },
        data: {
          authorisationLevel: 1,
          pageTitle: 'Visualizza storico conservazione'
        }
      }
    );
};

stateConfig.$inject = ['$stateProvider'];

export const ViewStoricoConservazioneModule: string = ng
  .module('viewStoricoConservazioneModule', [
    'ui.bootstrap',
    uiRouter,
    'ncy-angular-breadcrumb'
  ])
  .component('viewStoricoConservazioneComponent', ViewStoricoConservazioneComponent)
  .config(stateConfig)
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/usersettings/view-storico-utilizzo/view-storico-utilizzo.module.ts